"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const DescriptionList_vue_1 = __importDefault(require("./../DescriptionList.vue"));
const overdue_1 = __importDefault(require("../../api/overdue"));
const complex_plugin_1 = require("complex-plugin");
exports.default = (0, vue_1.defineComponent)({
    name: 'OverdueDetail',
    components: {
        DescriptionList: DescriptionList_vue_1.default
    },
    props: {
        detail: {
            type: Object,
            required: true
        },
        extraData: {
            type: Object,
            required: false
        },
        unOperate: {
            type: Boolean,
            required: false
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        }
    },
    data() {
        const description = [
            {
                name: '融资总额',
                prop: 'cleanLeaseMoney'
            },
            {
                name: '融资期数',
                prop: 'incomeNumber'
            },
            {
                name: '月租金',
                prop: 'rent'
            },
            {
                name: '已还金额',
                prop: 'factRent'
            },
            {
                name: '剩余租金',
                prop: 'residueRent'
            },
            {
                name: '剩余本金',
                prop: 'residueCorpus'
            },
            {
                name: '逾期天数',
                prop: 'maxDay'
            },
            {
                name: '逾期级别',
                prop: 'overdueRank',
                format(value) {
                    return value.label;
                }
            },
            {
                name: '逾期期数',
                prop: 'numb'
            },
            {
                name: '逾期租金',
                prop: 'rentOver'
            },
            {
                name: '逾期罚息',
                prop: 'penaltyOver'
            },
            {
                name: '逾期总额',
                prop: 'total'
            },
            {
                name: '逾期专项',
                prop: 'overdueProject'
            },
            {
                name: '车辆处置',
                prop: 'vehicleDisposal'
            },
            {
                name: '特殊情况1',
                prop: 'overSpecialSituation1',
                slot: 'overSpecialSituation1'
            },
            {
                name: '特殊情况2',
                prop: 'overSpecialSituation2',
                slot: 'overSpecialSituation2'
            },
            {
                name: '是否担保',
                prop: 'dealerGuaranteeFlag',
                slot: 'dealerGuaranteeFlag'
            },
            {
                name: '担保期限',
                prop: 'dealerGuaranteePeriod',
                slot: 'dealerGuaranteePeriod'
            },
            {
                name: '是否保全入库',
                prop: 'keepInStorageFlag',
                slot: 'keepInStorageFlag'
            },
            {
                name: '操作',
                prop: 'menu',
                slot: 'menu'
            },
            {
                name: '累计逾期天数',
                prop: 'cumulativeMaxDay',
            },
            {
                name: '累计逾期租金',
                prop: 'cumulativeTotalRent',
            },
            {
                name: '累计逾期罚息',
                prop: 'cumulativePenaltyOver',
            },
            {
                name: '累计逾期总额',
                prop: 'cumulativeTotal',
            },
        ];
        if (this.unOperate) {
            description.splice(description.length - 1, 1);
        }
        return {
            collapse: this.defaultCollapse,
            currentDetail: Object.assign({}, this.detail),
            description: description,
            select: {
                options: [
                    {
                        value: '0',
                        label: '否'
                    },
                    {
                        value: '1',
                        label: '是'
                    },
                ]
            }
        };
    },
    methods: {
        onSave(currentData) {
            overdue_1.default.overdueSpecialSituationChange.require({
                id: currentData.id,
                overSpecialSituation1: currentData.overSpecialSituation1,
                overSpecialSituation2: currentData.overSpecialSituation2,
                dealerGuaranteePeriod: currentData.dealerGuaranteePeriod,
                keepInStorageFlag: currentData.keepInStorageFlag
            }).then(() => {
                complex_plugin_1.notice.showMsg('修改成功！', 'success');
                this.detail.overSpecialSituation1 = currentData.overSpecialSituation1;
                this.detail.overSpecialSituation2 = currentData.overSpecialSituation2;
                this.detail.dealerGuaranteePeriod = currentData.dealerGuaranteePeriod;
                this.detail.keepInStorageFlag = currentData.keepInStorageFlag;
            });
        },
        onCollapseChange(value) {
            this.collapse = value;
        }
    }
});
